/**
 * The content gutter of the staff dashboard shell: the padding every dashboard
 * tab gets, and exactly what the Orders board renders inside (it adds none of
 * its own). The supplier portal shell uses the same class, so a page looks the
 * same in either shell.
 *
 * A page inside a shell must NOT pad itself again — that is how the Production
 * board ended up with twice the Orders gutter, and the Supplier Orders board
 * (which cut the shell's padding instead) with half. Use `ShellPage`.
 */
export const SHELL_CONTENT_CLASS = "px-4 py-6 sm:px-6 lg:px-6";
